module.exports = __webpack_public_path__ + "resources/img/img-zenius-ems-02-jp.35f533a55c9d145c3e0e5d82a5315cb3.png";